module.exports = __webpack_public_path__ + "static/strawberry-a51f138c730c31bfb86b13c098074ac0.svg";